export function handleKeyDown(e, index, otp, emit, focusInput, length) {
  if (e.key === 'Backspace') {
    if (otp[index]) {
      const next = [...otp];
      next[index] = '';
      emit(next);
    } else if (index > 0) {
      focusInput(index - 1);
    }
  } else if (e.key === 'ArrowLeft' && index > 0) {
    focusInput(index - 1);
  } else if (e.key === 'ArrowRight' && index < length - 1) {
    focusInput(index + 1);
  }
}

export function handlePaste(e, length, emit, focusInput) {
  e.preventDefault();
  const pasted = e.clipboardData
    .getData('text')
    .replace(/\D/g, '')
    .slice(0, length);
  if (!pasted) return;
  const next = Array(length).fill('');
  pasted.split('').forEach((ch, i) => {
    next[i] = ch;
  });
  emit(next);
  focusInput(Math.min(pasted.length, length - 1));
}
